import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import {
  faBell, faHouse, faPlus, faStore,
} from '@fortawesome/pro-light-svg-icons'

import { useSetState } from '@domain-group/react-hooks'

import {
  Box, Button, DashboardModule, SegmentedControl,
} from '@domain-group/suit-theme'

import useBrandCustomProfiles from '@hooks/useBrandCustomProfiles'
import useBrandCustomProfile from '@hooks/useBrandCustomProfile'

import BrandCustomProfileListItem from './BrandCustomProfileListItem'

interface BrandCustomProfilesProps {
  brandId: number,
}

const BrandCustomProfiles = (props: BrandCustomProfilesProps) => {
  const [state, setState] = useSetState({ filterKey: 'property_marketing' })
  const { filterKey } = state
  const { brandId } = props

  const brandCustomProfilesPayload = useBrandCustomProfiles({
    filters: { brand_id: brandId },
    performHttpRequests: !!brandId,
  })

  const { filteredBrandCustomProfiles } = brandCustomProfilesPayload

  const { callbacks: { createOrEditBrandCustomProfileModal } } = useBrandCustomProfile({ brand_id: brandId })

  return (
    <DashboardModule title="Custom User Permissions & Notifications">
      <Box
        flexDirection="column"
        style={{
          maxWidth: '100%',
          overflowX: 'auto',
          alignItems: 'center',
          display: 'flex',
        }}
      >
        <SegmentedControl
          activeButtonKey={filterKey}
          boxProps={{
            padding: 'small',
            margin: 'large',
            width: '97%',
            display: 'flex',
            justifyContent: 'center',
          }}
          buttons={[
            // @ts-expect-error TS2322
            { key: 'property_marketing', icon: faHouse, label: 'Property Marketing' },
            // @ts-expect-error TS2322
            { key: 'agency_marketing', icon: faStore, label: 'Agency Marketing' },
            // @ts-expect-error TS2322
            { key: 'notifications', icon: faBell, label: 'Notification Options' },
          ]}
          onClick={key => setState({ filterKey: key })}
        />

        {filteredBrandCustomProfiles.map(profile => (
          <BrandCustomProfileListItem
            brandCustomProfile={profile}
            filterKey={filterKey}
            key={profile.id}
          />
        ))}

        <DashboardModule.Footer boxProps={{ borderTop: '1px solid' }}>
          <DashboardModule.FooterRight>
            <Button
              buttonStyle="secondaryEdit"
              icon={<FontAwesomeIcon icon={faPlus} />}
              onClick={() => createOrEditBrandCustomProfileModal()}
          // @ts-expect-error TS2322
              size={['medium', 'small']}
              width={['100%', 'fit-content']}
            >
              Create Profile
            </Button>
          </DashboardModule.FooterRight>
        </DashboardModule.Footer>
      </Box>
    </DashboardModule>
  )
}

export default BrandCustomProfiles
